module.exports = __webpack_public_path__ + "static/media/Arvalli.038a72e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Arvalli.png
// module id = 1010
// module chunks = 0